// Convert integer day offset to "W{n}D{n}" format
const formatRelativeDay = (day) => {
    if (day == null) return '';
    const week = Math.ceil(day / 7);
    const dayInWeek = ((day - 1) % 7) + 1;
    return `W${week}D${dayInWeek}`;
};

// Check if a relative day is a weekend (Saturday or Sunday)
const isTemplateWeekend = (day) => {
    return day % 7 === 6 || day % 7 === 0;
};

// Count working days between start and end (inclusive), subtracting weekends unless marked as worked
const calculateTemplateDuration = (start, end, weekendWorkData) => {
    if (start == null || end == null) return '';
    let workingDays = 0;
    for (let d = start; d <= end; d++) {
        if (isTemplateWeekend(d)) {
            if (weekendWorkData && weekendWorkData[String(d)] === true) {
                workingDays++;
            }
        } else {
            workingDays++;
        }
    }
    return workingDays > 0 ? workingDays : '';
};

// Calculate effective relative date range from subtasks (template equivalent of getEffectiveDateRange)
const getEffectiveRelativeDateRange = (task, allTasks) => {
    const subtasks = allTasks.filter(t => String(t.mainTaskId) === String(task.taskId) && t.projectId === task.projectId);
    if (subtasks.length === 0) {
        return { start: task.relativeStart, end: task.relativeEnd };
    }

    const startValues = subtasks
        .map(st => st.relativeStart)
        .filter(v => v != null);
    const start = startValues.length > 0
        ? Math.min(...startValues)
        : null;

    const endValues = subtasks
        .map(st => st.relativeEnd)
        .filter(v => v != null);
    const end = endValues.length > 0
        ? Math.max(...endValues)
        : null;

    return { start, end };
};

export { formatRelativeDay, isTemplateWeekend, calculateTemplateDuration, getEffectiveRelativeDateRange };
